import { KIZEN_PREFIX } from 'storage';

import { LocalStorage } from 'utility/LocalStorage.js';

import { KizenStepType } from '../types';

export const AUTOMATION_COPY_KEY = `${KIZEN_PREFIX}automation-copy`;

type AutomationCopyLocalStorageStep = {
  contextObjectId: string;
  step: object;
  type: KizenStepType;
};

export class AutomationCopyLocalStorage extends LocalStorage {
  constructor(
    key = 'key',
    { serialize = JSON.stringify, deserialize = JSON.parse } = {}
  ) {
    super(key, { serialize, deserialize });
  }

  set step({ contextObjectId, step, type }: AutomationCopyLocalStorageStep) {
    const val = { ...this.val, [contextObjectId]: { step, type } };
    this.val = val;
  }

  stepByContextObjectId = (contextObjectId: string) => {
    const step = (this.val || {})[contextObjectId];
    return step;
  };
}

export const automationCopyLocalStorage = new AutomationCopyLocalStorage(
  AUTOMATION_COPY_KEY
);
